import styled from 'styled-components';
import {FormRadio} from '../../../atoms/form/radio';

export const RadioWrapper = styled.div`
    ${FormRadio} {
        padding: 9px 20px 9px 0;
    }

    ${FormRadio}:last-of-type {
        padding-right: 0;
    }
`;